export default "__VITE_ASSET__mnoix3lt__"